module.exports = __webpack_public_path__ + "img/accountRecover.fef13fcd.webp";